module.exports = __webpack_public_path__ + "media/stylesheets/images/main/introduce_ceo_lg_2-bb925854e9e6f7fd84a3bb5ef468b8ab.png";